export const alphanumericRegex = /^[a-zA-Z0-9]+$/;
export const latinLettersNumericRegex = new RegExp(/^[a-z0-9\s-_.,]+$/i);
export const onlyAlphanumericRegex = /[^a-zA-Z0-9]/g;
